import React, { Component } from 'react';
import style from './contentbox.less';

export default class Contentbox extends Component {
    render() {
        return (
            <main className={style.contentbox}>
                <div className={style.contentbox__wrapper}>
                    <div className={style.contentbox__pageBox}>
                        { this.props.children }
                    </div>
                </div>
            </main>
        );
    }
}


